// action/create-support-ticket.tsx

import React from "react";
import { CardShell, FieldLabel } from "./card-handler";
import { ActionNode } from "../../../../views/convoauto-pages/bot-studio/types";
import { ChevronDown } from "lucide-react";

const PRIORITY_OPTIONS = [
  { label: "High", value: "high" },
  { label: "Medium", value: "medium" },
  { label: "Low", value: "low" },
];

interface CreateSupportTicketCardProps {
  node: ActionNode;
  onUpdate: (config: Record<string, any>) => void;
  onDelete: () => void;
  onReset: () => void;
  bare?: boolean;
}

export const CreateSupportTicketCard: React.FC<CreateSupportTicketCardProps> = ({
  node,
  onUpdate,
  onDelete,
  onReset,
  bare,
}) => {
  const config = node.config ?? {};

  const update = (patch: Record<string, any>) => onUpdate({ ...config, ...patch });

  return (
    <CardShell
      title="Create Support Ticket"
      description="Create a ticket for your team"
      onDelete={onDelete}
      onReset={onReset}
      bare={bare}
    >
        <div className="mb-4">
          <FieldLabel>Priority</FieldLabel>
          <div className="relative">
            <select
              value={config.priority ?? "high"}
              onChange={(e) => update({ priority: e.target.value })}
              className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2.5 text-sm appearance-none bg-white dark:bg-gray-900 pr-8 focus:outline-none focus:ring-1 focus:ring-indigo-300"
            >
              {PRIORITY_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            <ChevronDown size={16} className="absolute right-3 top-3 text-[#7B7B7B] font-semibold dark:text-gray-500 pointer-events-none" />
          </div>
        </div>

        <div>
          <FieldLabel>Notes (Optional)</FieldLabel>
          <textarea
            value={config.notes ?? ""}
            onChange={(e) => update({ notes: e.target.value })}
            placeholder="This is a first time customer."
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2.5 text-sm min-h-[80px] focus:outline-none focus:ring-1 focus:ring-indigo-300 resize-y"
          />
        </div>
    </CardShell>
  );
};